module.exports = __webpack_public_path__ + "assets/img/2.69642eb0.jpg";